// import { useProductActions } from "../context/ProductContext";
import { useFormContext } from "react-hook-form";
import { useBundleContext } from "../context/BundlesContext";
import { isInternal } from "../helpers/isInternal";

export const useResetForm = (defaultValues) => {
  const { reset } = useFormContext();
  const { setSelectedBundle } = useBundleContext();

  // const { resetFormDetails } = useFormDetailsActions();
  // const { resetPrintState } = usePrintActions();
  // const { resetProducts } = useProductActions();
  // const { setToken } = useAuthentication();
  return () => {
    setSelectedBundle(null);
    reset({ stock_photos: [], ...defaultValues });
    // resetFormDetails();
    // resetPrintState();
    // resetProducts();
    if (isInternal()) {
      // setToken();
    }
  };
};
